import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import styled from '@rsos/theme/styled';

export const PANE_WIDTH = 360;

// Shared base pane container. Used by W3wCallPane. Relocated here from the
// now-removed legacy CallPane component.
export const StyledCallPane = styled.div`
  padding: 15px;
  width: ${PANE_WIDTH}px;
  border-right: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 0;
  @media (max-width: ${BP_LAPTOP}px) {
    width: 100%;
  }
  background-color: inherit;
  .Resizer {
    background: inherit;
  }
`;
